import React, { useState } from "react";
import { Alert, Typography } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { useUserInfoQuery } from "../../../api/userApiSlice";
import { useGetDUCInfoQuery } from "../../../api/ducApiSlice";
import { colours } from "../../../StyleConstants";

const OwnershipTransferBanner: React.FC = () => {
    const { data: userData } = useUserInfoQuery({});
    const { data: ducDataObject } = useGetDUCInfoQuery({ email: userData?.email });

    // Top-level flag alongside ducStatus/piTrainingComplete - set once the new PI's DUC (from an
    // ownership transfer) is approved but their training isn't complete yet, the only window where
    // the group's access is actually gated because of the transfer.
    const pending: boolean = ducDataObject?.ownershipTransferPending === true;
    const isSubApplicant: boolean = ducDataObject?.subApplicantGeneral === true;

    // Dismissal is in-memory only, matching DucExpiryBanner - reappears on each visit while pending.
    const [dismissed, setDismissed] = useState(false);

    if (!pending || dismissed) return null;

    const handleClose = () => {
        setDismissed(true);
    };

    return (
        <Alert
            role="alert"
            onClose={handleClose}
            icon={<WarningAmberRoundedIcon fontSize="inherit" sx={{ color: colours.core.white }} />}
            sx={{
                backgroundColor: colours.warning.warn,
                color: colours.core.white,
                borderRadius: 1,
                alignItems: "center",
                "& .MuiAlert-action": { color: colours.core.white },
                "& .MuiAlert-action .MuiSvgIcon-root": { color: colours.core.white },
            }}
        >
            <Typography fontWeight="500" sx={{ color: colours.core.white }}>
                {isSubApplicant
                    ? "Lead Investigator change in progress. You will regain data access once the new investigator completes training."
                    : "Data access requires completion of the Responsible Data and Biospecimen Use Training."}
            </Typography>
        </Alert>
    );
};

export default OwnershipTransferBanner;
